import React, { useReducer, useEffect, useCallback, useMemo } from 'react';
import DateFieldSchedulerGeneratorView from '../view/DateFieldSchedulerGeneratorView';

const defualtState = fId => ({
  condition: {
    conditionType: 'date',
    interval: 30,
    intervalUnit: 'day',
    dateOperator: 'after',
    dateFieldName: fId
  }
});

const DateFieldBasedReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'update':
      return { ...state, ...payload };

    case 'update_condition':
      return {
        ...state,
        condition: { ...(state.condition || {}), ...payload }
      };
    default:
      return state;
  }
};

/**
 *
 * @param {Object} schedule - Object that holds data for the view to use (format = mock object at the top)
 * @param {Function} update - A function to get the updated dataBlock
 */
const DateFieldSchedulerGeneratorEngine = ({
  schedule,
  update = dBlock => dBlock,
  dateFields = []
}) => {
  const [data, dispatch] = useReducer(
    DateFieldBasedReducer,
    schedule || defualtState((dateFields[0] || {}).internalId)
  );

  useEffect(() => {
    // if (shouldSkipUpdate()) {
    //   return;
    // }
    update(data);
  }, [data]);

  const setInterval = useCallback(v => {
    let value = parseInt(v.target.value.replace(/[^\d.]+/g, ''));
    if (value < 0) {
      value = 0;
    }
    // if (value > 999) {
    //   value = 999;
    // }

    dispatch({ type: 'update_condition', payload: { interval: value } });
  }, []);

  const dateFieldOptions = useMemo(
    () =>
      dateFields.map(f => ({
        value: f.internalId,
        text: f.title || `Untitled ${f.uiType} field`,
        'data-testid': `date-field-${f.internalId}`
      })),
    [dateFields]
  );

  const viewProps = {
    interval: data.condition.interval,
    intervalUnit: data.condition.intervalUnit,
    dateOperator: data.condition.dateOperator,
    dateFieldName: data.condition.dateFieldName,
    dateFieldOptions,
    setInterval,
    dispatch
  };

  return <DateFieldSchedulerGeneratorView {...viewProps} />;
};

export default DateFieldSchedulerGeneratorEngine;
